// sets the value in the --vh css custom property to the root of the document
const update_virtual_height_css = () =>
  document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`)

window.addEventListener("resize", update_virtual_height_css)
update_virtual_height_css()
